'use strict';

const linkSelector = '.mobileChildButton';
const itemSelector = '.mobile-nav-group__list-item';
const backSelector = '.global-nav__item--back';
const itemActiveClass = 'mobile-nav-group__list-item--active';
const parentActiveClass = 'is-active';
const menuActiveClass = 'nav-open';
const menuBtnId = 'nav-btn';
const mobileNavId = 'global-nav-mobile';

export default function () {
    const links = document.querySelectorAll(linkSelector);
    const backLinks = document.querySelectorAll(backSelector);
    const body = document.querySelector('body');
    const menuBtn = document.getElementById(menuBtnId);
    const mobileNav = document.getElementById(mobileNavId);

    if (menuBtn) {
        menuBtn.addEventListener('click', () => {
            const isOpening = !body.classList.contains(menuActiveClass);

            body.classList.toggle(menuActiveClass);
            menuBtn.classList.toggle('is-toggled');
            mobileNav.classList.toggle('is-toggled');

            resetMenu(isOpening);
        });
    }

    links.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            process(link);
        });
    });

    backLinks.forEach(backLink => {
        backLink.addEventListener('click', () => backProcess(backLink));
    });
}

function resetMenu(isOpening = false) {
    if (isOpening) return;

    setTimeout(() => {
        const scope = document.getElementById(mobileNavId) || document;
        scope.querySelectorAll(itemSelector).forEach(el => el.classList.remove(itemActiveClass));
        scope.querySelectorAll('.global-nav__list, .global-nav__child').forEach(list => list.classList.remove(parentActiveClass));
        document.body.classList.remove(menuActiveClass);
    }, 250);
}

function process(link) {
    const parentUL = link.closest('ul');
    if (!parentUL) return;

    const items = parentUL.querySelectorAll(itemSelector);
    items.forEach(i => i.classList.remove(itemActiveClass));
    document.querySelector('.global-nav--level-0').classList.remove('no-scroll');

    const li = link.closest('li');
    if (li) li.classList.add(itemActiveClass);
    document.querySelector('.global-nav--level-0').classList.add('no-scroll');

    const childList = li ? (li.querySelector('.global-nav__list') || li.querySelector('.global-nav__child') || link.nextElementSibling) : null;

    const scope = document.getElementById(mobileNavId) || document;
    scope.querySelectorAll('.global-nav__list, .global-nav__child').forEach(list => {
        if (list !== childList) list.classList.remove(parentActiveClass);
    });

    if (childList) {
        childList.classList.add(parentActiveClass);
    } else {
        parentUL.classList.remove(parentActiveClass);
    }
}

function backProcess(backLink) {
    const childList = backLink.closest('.global-nav__list, .global-nav__child');

    if (childList) {
        childList.classList.remove(parentActiveClass);
        const triggeringLI = childList.closest('li');
        if (triggeringLI) triggeringLI.classList.remove(itemActiveClass);
        document.querySelector('.global-nav--level-0').classList.remove('no-scroll');
    } else {
        const li = backLink.closest('li');
        if (li) li.classList.remove(itemActiveClass);
        document.querySelector('.global-nav--level-0').classList.remove('no-scroll');
    }
}
